import React, { Component } from "react";
import { Layout, Row, Col, Space, Button, List, Typography, Card, message, Popconfirm } from "antd";

//Componentes
import ModalCentrosCostos from "./ModalCentrosCostos";
import { IconDelete, IconDetails, IconEdit } from "../../../Widgets/Iconos";
import FloatingButton from "../../../Widgets/Floating Button/FloatingButton";

const { Content } = Layout;
const { Text } = Typography;

const axios = require('axios')
const moment = require('moment')

/**
 * @export
 * @class CentrosCostos
 * @extends {Component}
 * @description Vista del listado de los centros de Costos
 * 
 * NOTA (05/06/2025) Para el momento que se esta haciendo esta vista es exclusiva para el cliente Balluff
 * Pero esto puede funcionar con otros clientes, Los Centros de Costos serian algo asi como las AREAS del sistema, pero lo usan los clientes de Balluff 
 * para separar las compras (ORDENES VMI) por departamantos de su empresa
 * 
 */
class CentrosCostos extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            centro_costo_id: undefined,
            centros_costos: {
                data: [],
                limit: 10,
                page: 1,
                total: 0,
                pages: 0,
                cliente_id: this.props.cliente_id
            }
        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        if(this.props.cliente_id){
            this.getCentrosCostos()
        }
    }

    /**
    * @memberof CentrosCostos
    * @description Obtiene los centros de costo cliente
    * @param transacciones Objeto de paginación
    */
    getCentrosCostos = ({
        page = this.state.centros_costos.page,
        limit = this.state.centros_costos.limit
    } = this.state.centros_costos) => {
        this.setState({loading: true})
        axios.get('/centros',{
            params: {
                page,
                limit,
                cliente_id: this.props.cliente_id
            }
        }).then(({data})=>{
            console.log('data',data);
            this.setState({
                centros_costos:{
                    page: data.page,
                    limit: data.limit,
                    data: data.data,
                    total: data.total,
                }

            })

        }).catch(error => {
            console.log('error',error);
            message.error(error?.response?.data.message ?? "Error al obtner la lista de Centros")
        }).finally(()=>this.setState({loading: false}))
    }
   

    /**
    * @memberof CentrosCostos
    * @description Elimina un centro de control
    */
    deleteCentro = (centro_costo_id) => {
        this.setState({loading: true})
        axios.delete('/centros',{
            params:{
                centro_costo_id
            }
        }).then(()=>{
            message.success("Eliminado")
            this.getCentrosCostos()
        }).catch((error)=>{
            console.log(error?.response?.data?.message ?? "Error al eliminar")
            message.error(error?.response?.data?.message ?? "Error al eliminar")
        }).finally(()=>this.setState({loading: false}))
    }

    /**
    * @memberof CentrosCostos
    * @description Cierra el modal y recarga la lista
    */
    closeModal = () => {
        this.setState({modalVisible: false, centro_costo_id: undefined})
        this.getCentrosCostos()
    }



    render() {
        return (
            <>
                <List
                    loading={this.state.loading}
                    className="component-list "
                    size="large"
                    itemLayout="horizontal"
                    locale={{emptyText: "No hay centros de costos registrados, al momento de crear uno, el cliente tandra habilitadas los centros de costos para añadir a sus compras"}}
                    dataSource={this.state.centros_costos.data}
                    header={<Row className="header-list width-100 pl-1 pr-1 ">
                        <Col xs={24} md={5} className=" center">
                            <Text strong>Nombre</Text>
                        </Col>
                        <Col xs={24} md={10} className="center">
                            <Text strong>Descripción</Text>
                        </Col>
                        <Col xs={24} md={5} className=" center">
                            <Text strong>Limite</Text>
                        </Col>
                    </Row>
                    }
                    renderItem={item => (
                        <List.Item className="component-list-item ">
                            <Card className="card-list">
                                <Row className="width-100">
                                    <Col xs={24} md={5} className="center">
                                        <Text ellipsis className="text-gray-dark">{item.nombre}</Text>
                                    </Col>
                                    <Col xs={24} md={10} className="center">
                                        <Text ellipsis className="text-gray-dark">{item.descripcion ?? "-"}</Text>
                                    </Col>
                                    <Col xs={24} md={5} className="center">
                                        <Text ellipsis className="text-gray-dark">$ {item.limite?.toMoney(true) ?? "-"} MXN</Text>
                                    </Col>
                                    <Col xs={24} md={4} className="center">
                                        <Space>
                                            <Button
                                                type="primary"
                                                icon={<IconEdit />}
                                                title="Editar"
                                                onClick={() => { this.setState({ modalVisible: true, centro_costo_id: item._id }) }}

                                            />
                                            <Popconfirm
                                                placement="topRight"
                                                title="¿Deseas eliminar este Centro?"
                                                onConfirm={() =>this.deleteCentro(item._id)}
                                                okText="Si"
                                                cancelText="No"
                                            >
                                                <Button
                                                    type="primary"
                                                    icon={<IconDelete />}
                                                    title="Eliminar"
                                                    danger
                                                />
                                            </Popconfirm>
                                        </Space>
                                    </Col>
                                </Row>
                            </Card>
                        </List.Item>
                    )}

                />
                <FloatingButton title="Nuevo registro" onClick={() => this.setState({ modalVisible: true })} />
                <ModalCentrosCostos
                    visible={this.state.modalVisible}
                    onClose={this.closeModal}
                    cliente_id={this.props.cliente_id}
                    centro_costo_id={this.state.centro_costo_id}
                />
            </>
        )
    }
}

export default function (props) {
    return (<CentrosCostos {...props} />)
}